export function useFormatCurrency() {
  const convertToCurrency = (val) => {
    if (val === null) return null;
    if (isNaN(Number(val))) return val;

    return Number(val).toLocaleString('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    });
  };

  const convertToCurrencyFormat = (val) => {
    if (val === null) return null;
    if (isNaN(Number(val))) return val;

    return val.toLocaleString('nl-NL', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return { convertToCurrency, convertToCurrencyFormat };
}
